export default __webpack_public_path__ + "static/domea-6-54a4b2ae251bfd251692db2d0c7776cc.jpg";